import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { AttendantDataState } from '@/zustand/interfaces/attendant-data';

export const useAttendantData = create<
  AttendantDataState,
  [['zustand/persist', unknown]]
>(
  persist(
    (set) => ({
      user: null,
      token: null,
      setAttendantData: (user) =>
        set({
          user
        }),
      setAttendantToken: (token) =>
        set({
          token
        }),
      removeAttendantData: () =>
        set({
          user: null,
          token: null
        })
    }),
    {
      name: 'attendantData',
      storage: createJSONStorage(() => localStorage)
    }
  )
);
